import React from 'react';

import '../icon-component.scss';

const UserComponent = () => (
  <svg className="icon-component" viewBox="0 0 16 20">
    <path d="M8,9 C5.51471863,9 3.5,6.98528137 3.5,4.5 C3.5,2.01471863 5.51471863,-1.77635684e-15 8,-1.77635684e-15 C10.4852814,-1.77635684e-15 12.5,2.01471863 12.5,4.5 C12.5,6.98528137 10.4852814,9 8,9 L8,9 Z M8,1 C6.06700338,1 4.5,2.56700338 4.5,4.5 C4.5,6.43299662 6.06700338,8 8,8 C9.93299662,8 11.5,6.43299662 11.5,4.5 C11.5,2.56700338 9.93299662,1 8,1 L8,1 Z" />
    <path d="M14.71,20 L1.29,20 C1.01385763,20 0.79,19.7761424 0.79,19.5 C0.79,9.97 5.52,9.5 5.72,9.5 C5.83270659,9.48888466 5.94578375,9.51715395 6.04,9.58 L8.04,10.89 L10.04,9.58 C10.1338676,9.51637007 10.2472321,9.48802894 10.36,9.5 C10.56,9.5 15.29,9.97 15.29,19.5 C15.2919051,19.6477089 15.2283969,19.7887002 15.1165114,19.8851532 C15.0046259,19.9816062 14.8558161,20.0236477 14.71,20 L14.71,20 Z M1.8,19 L14.2,19 C14.07,11.81 11.06,10.69 10.35,10.53 L8.28,11.92 C8.11084213,12.0343383 7.88915787,12.0343383 7.72,11.92 L5.65,10.53 C4.95,10.7 1.93,11.87 1.8,19 L1.8,19 Z" />
  </svg>
);

UserComponent.displayName = 'UserIcon';

export default UserComponent;
